import React from 'react';
import { Loader } from 'is24-corecss';
import { useBillCheckV3 } from '../../hooks/useBillCheckV3.hook';
import { OverviewDescription } from './OverviewDescription';
import { BillCheckV3OverviewTab } from './BillCheckV3OverviewTab';
import { BillCheckLegacyOverviewTab } from './BillCheckLegacyOverviewTab';
import { useLegacyBillCheck } from '@/customHooks/useLegacyBillCheck.hook';

const styles = {
  overviewTab: { maxWidth: 530 },
};

export const OverviewTab = ({ isEntitled }: { isEntitled: boolean }) => {
  const { lastBillCheck: lastV3BillCheck, areProductsRefetching } = useBillCheckV3();
  const { lastBillCheck: lastLegacyBillCheck } = useLegacyBillCheck();

  if (areProductsRefetching) {
    return <Loader />;
  }

  if (!lastV3BillCheck && !lastLegacyBillCheck) {
    return (
      <div style={styles.overviewTab}>
        <OverviewDescription isEntitled={isEntitled} />
      </div>
    );
  }

  return (
    <div style={styles.overviewTab}>
      {lastV3BillCheck ? (
        <BillCheckV3OverviewTab lastBillCheck={lastV3BillCheck} isEntitled={isEntitled} />
      ) : (
        <BillCheckLegacyOverviewTab lastBillCheck={lastLegacyBillCheck!} isEntitled={isEntitled} />
      )}
    </div>
  );
};
